import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { DeleteParticipantRestrictivePractice } from '../mutations/deleteParticipantRestrictivePractice.mutation';
import type {
  DeleteParticipantRestrictivePracticeMutation,
  DeleteParticipantRestrictivePracticeMutationVariables,
} from '../types';

export const useDeleteParticipantRestrictivePracticeMutation = (
  options?: MutationOptions<
    DeleteParticipantRestrictivePracticeMutation,
    DeleteParticipantRestrictivePracticeMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantRestrictivePractice), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
